import React from 'react';
import Button from '../../components/Form/Button';
import { DeliveryNote, DeliveryNoteItem } from '../../types';

interface DeliveryNoteItemsRowProps {
  note: DeliveryNote;
  colSpan: number;
  requisitionInfo: string;
  onItemDelivered: (note: DeliveryNote, item: DeliveryNoteItem) => void;
}

/** Expanded row showing a delivery note's items with per-item delivery status */
const DeliveryNoteItemsRow: React.FC<DeliveryNoteItemsRowProps> = ({ note, colSpan, requisitionInfo, onItemDelivered }) => {
  const items = note.technicalPart || [];
  return (
    <tr className="bg-gray-50">
      <td colSpan={colSpan} className="px-6 py-4">
        <p className="text-xs font-semibold text-gray-600 uppercase mb-2">
          Items — {requisitionInfo}
        </p>
        <table className="min-w-full text-sm border border-gray-200 rounded">
          <thead className="bg-gray-100">
            <tr>
              {['#', 'Item', 'Qty', 'ROB', 'App Qty', 'Unit Price', 'Deliver Qty', 'Status', 'Actions'].map((h) => (
                <th key={h} className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {items.map((item: any, idx: number) => {
              const delivered = item.status === 'delivered';
              return (
                <tr key={item.id || idx}>
                  <td className="px-3 py-2">{item.no || idx + 1}</td>
                  <td className="px-3 py-2 font-medium text-gray-900">{item.type || '-'}</td>
                  <td className="px-3 py-2">{item.qty ?? '-'}</td>
                  <td className="px-3 py-2">{item.rob || '-'}</td>
                  <td className="px-3 py-2">{item.appQty ?? '-'}</td>
                  <td className="px-3 py-2">{Number(item.unitPrice || 0).toLocaleString()}</td>
                  <td className="px-3 py-2">{item.quantity ?? '-'}</td>
                  <td className="px-3 py-2">
                    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
                      delivered ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {delivered ? 'Delivered' : 'Pending'}
                    </span>
                  </td>
                  <td className="px-3 py-2">
                    {delivered ? (
                      <span className="text-xs text-gray-400">Done</span>
                    ) : (
                      <Button onClick={() => onItemDelivered(note, item)} variant="primary" size="sm" className="text-xs">Mark Delivered</Button>
                    )}
                  </td>
                </tr>
              );
            })}
            {items.length === 0 && (
              <tr><td colSpan={9} className="px-3 py-3 text-center text-gray-500">No items on this note</td></tr>
            )}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

export default DeliveryNoteItemsRow;
